import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-meta-table',
  templateUrl: './meta-table.component.html',
  styleUrls: ['./meta-table.component.css']
})
export class MetaTableComponent implements OnInit {
    public metaTableKeyno: string;

    public edit?: Edit;

    public selectListRelatedTo: RelatedToItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.metaTableKeyno = this.stateService.getStateParams()['metatable_keyno'];
    }

    private async loadEdit() {
        if (!!this.metaTableKeyno) {
            this.edit = (await this.datatask.Post(2372, { metatable_keyno: this.metaTableKeyno }))[0];
        }
    }

    private async loadRelatedTo(): Promise<void> {
        this.selectListRelatedTo = await this.datatask.Post(2373);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2374, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2376, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back(2);
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        switch (id) {
            case 'table_name_related_to':
                if (!!this.edit) {
                    this.edit.metatable_table_name = this.edit.table_name_related_to;
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadRelatedTo();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    metatable_keyno: string;
    metatable_name: string;
    metatable_table_name: string;
    table_name_related_to: string;
    delete_warning: string;
}

interface RelatedToItem {
    table_name_related_to: string;
    table_name_related_to_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTable', {
//        templateUrl: 'views/components/views/metaTable/metaTable.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'metaTableService', function ($stateParams, stateService, utilityService, translateService, modalService, metaTableService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                metaTableKeyno: metaTableKeyno,
//                edit: {},
//                selectListRelatedTo: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await metaTableService.getMetaTable({ metatable_keyno: metaTableKeyno }))[0];
//            }

//            async function loadRelatedToMetaTables() {
//                vm.model.selectListRelatedTo = await metaTableService.listRelatedToMetaTables();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'table_name_related_to':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.table_name_related_to) !== true) return;

//                        vm.model.edit.table_name_related_to = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.table_name_related_to, true) !== true) return;

//                        vm.model.edit.metatable_table_name = vm.model.edit.table_name_related_to;
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                metaTableService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: vm.model.edit.delete_warning,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    metaTableService.deleteObj(vm.model.edit).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: (dialogItself) => {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back(2);
//                        }
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadRelatedToMetaTables();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
